import { useEffect, useState } from 'react'
import useDocumentGenerationHandler, { DocumentGenerationType } from '../document/useDocumentGenerationHandler'
import { QueueStatus } from '../useQueueStateHandler'

export type ErrorNotification = {
    message?: string
    trace?: string
    generationType?: DocumentGenerationType
    state?: string
}

export default function useProcessErrorNotification() {
    const [notification, setNotification] = useState<ErrorNotification>()
    // @todo implement generic error handling that is not dependent on the document generation handling.
    const handler = useDocumentGenerationHandler()

    useEffect(() => {
        if (notification) {
            handler.transition(notification.state, QueueStatus.Failed, {
                error: {
                    message: notification.message,
                    trace: notification.trace,
                },
            })
        }
    }, [notification])

    return setNotification
}
